// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status-pill {\n  display: block;\n  padding: .25rem .5rem;\n  font-size: .875rem;\n  font-weight: 500;\n  box-sizing: border-box;\n  border-radius: .25rem; }\n\n.status-pill.green {\n  background-color: #cbf4c9;\n  border: 1px solid #c5f4c3;\n  color: #247448; }\n\n.status-pill.red {\n  background-color: #f4c9c9;\n  border: 1px solid #f4c3c3;\n  color: #a52525; }\n\n.status-pill.yellow {\n  background-color: #fff5ad;\n  border: 1px solid #fff39a;\n  color: #7c7c01; }\n", ""]);
// Exports
module.exports = exports;
